/*
 * エディット用mixin
 */
<script>
export default {
	computed: {
		REQUIRED_EMPTY_COL: function( ) {
			return "required_empty_col";
		},
		UPDATING_COL: function( ) {
			return "updating_col";
		},
	},
	methods: {
		/**
		 * エディットタイプ取得<br>
		 * for 必須項目エディット<br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 *
		 * @function  getEditClassType
		 * @returns result
		 * @instance
		 */
		getEditClassType: function( text, oldText ) {
			if( text === "" ) {
				// 必須項目で未入力の場合 
				return this.REQUIRED_EMPTY_COL;
			} else if ( text !== oldText){
				// 編集中
				return this.UPDATING_COL;
			}
			else {
				return "";
			}
		},
		/**
		 * 数値を比較しエディタータイプ取得<br>
         * for 必須項目エディット<br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 *
		 * @function  getNumClassType
		 * @returns result
		 * @instance
		 */
		getNumClassType: function( num, oldNum ) {
			if( num == -2 ) {
				return this.REQUIRED_EMPTY_COL;
				
			} else if ( num !== oldNum){
				return this.UPDATING_COL;
			}
			else {
				return "";
			}
		},
		/**
		 * 必須ではないタイプ取得 <br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 * 一行編集画面で使用 <br>
		 *
		 * @function  getAnyEditClassType
		 * @returns result
		 * @instance
		 */
		getAnyEditClassType: function( text, oldText ) {
			if ( text !== oldText){
				return this.UPDATING_COL;
			}
			else {
				return "";
			}
		},
		/**
		 * 必須ではないタイプ取得 <br>
		 * ******* 内部処理 *******<br>
		 * データを受け取り比較する。 <br>
		 * 一行編集画面で使用 <br>
		 *
		 * @function  getAnyNumClassType
		 * @returns result
		 * @instance
		 */
		getAnyNumClassType: function( text, oldText ) {
			if ( text != oldText){
				return this.UPDATING_COL;
			}
			else {
				return "";
			}
		},
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/Edit.mixin.vue